import React from 'react';
import './styles.css'; // Ensure you import the stylesheet

const DynamicRotatingSlash = () => {
  return <span className="unix-spin text-xs font-mono text-green-400"></span>;
};

export default DynamicRotatingSlash;
